import { render } from "./Privacy.vue?vue&type=template&id=9c91ed5c"
import script from "./Privacy.vue?vue&type=script&lang=js"
export * from "./Privacy.vue?vue&type=script&lang=js"
script.render = render

export default script